import { IconPlusSmall } from 'central-icons/IconPlusSmall';

import { requestFilterMenuOpen } from '../../../filters/components/filter-menu-open-signal';
import styles from './ScreenerEmptyState.module.css';

const FoldedMapGlyph = () => (
  <svg
    className={styles.glyph}
    width="142"
    height="142"
    viewBox="0 0 142 142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <polygon
      points="10.5,38 10.5,126 49,104 93,126 131.5,104 131.5,16 93,38 49,16"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinejoin="round"
      fill="none"
    />
    <line
      x1="49"
      y1="16"
      x2="49"
      y2="104"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <line
      x1="93"
      y1="38"
      x2="93"
      y2="126"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

export const ScreenerEmptyState = () => {
  return (
    <div className={styles.emptyState} data-testid="screener-empty-state">
      <FoldedMapGlyph />
      <h2 className={styles.heading}>Start discovering workforce trends</h2>
      <p className={styles.body}>
        Use filters to uncover regional patterns in attrition, hiring, tenure,
        compensation, and growth.
      </p>
      <button
        type="button"
        className={styles.ctaButton}
        onClick={requestFilterMenuOpen}
      >
        <IconPlusSmall size="16px" />
        Add Filters
      </button>
    </div>
  );
};
